(function () {
  'use strict';

  function getSectionId() {
    var grid = document.getElementById('product-grid');
    return grid && grid.dataset.id ? grid.dataset.id : null;
  }

  function getHubPath() {
    var toolbar = document.querySelector('[data-eride-collection-hub]');
    var handle = toolbar && toolbar.dataset.hubHandle ? toolbar.dataset.hubHandle : 'all';
    return '/collections/' + handle;
  }

  function setLoading(isLoading) {
    var toolbar = document.querySelector('[data-eride-collection-hub]');
    if (!toolbar) return;
    toolbar.classList.toggle('is-loading', isLoading);
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    var collection = container.querySelector('.collection');
    if (collection) collection.classList.toggle('loading', isLoading);
  }

  function updateCollectionTitle(pill) {
    var title = document.getElementById('eride-collection-title');
    if (!title || !pill) return;
    title.textContent = pill.textContent.trim();
  }

  function setActivePill(pill) {
    document.querySelectorAll('[data-eride-category-pill]').forEach(function (el) {
      el.classList.remove('is-active');
      el.removeAttribute('aria-current');
    });
    if (!pill) return;
    pill.classList.add('is-active');
    pill.setAttribute('aria-current', 'true');
    updateCollectionTitle(pill);
  }

  function findPillByMode(mode, value) {
    var selector = '[data-eride-category-pill][data-category-mode="' + mode + '"]';
    if (value) selector += '[data-filter-value="' + CSS.escape(value) + '"]';
    if (mode === 'collection' && value) {
      selector = '[data-eride-category-pill][data-category-mode="collection"][data-collection-handle="' + CSS.escape(value) + '"]';
    }
    return document.querySelector(selector);
  }

  function updateProductCount(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var count = parsed.getElementById('ProductCount');
    var countDesktop = parsed.getElementById('ProductCountDesktop');
    if (count && document.getElementById('ProductCount')) {
      document.getElementById('ProductCount').innerHTML = count.innerHTML;
    }
    if (countDesktop && document.getElementById('ProductCountDesktop')) {
      document.getElementById('ProductCountDesktop').innerHTML = countDesktop.innerHTML;
    }
  }

  function replaceProductGrid(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var source = parsed.getElementById('ProductGridContainer');
    var target = document.getElementById('ProductGridContainer');
    if (!source || !target) return false;
    target.innerHTML = source.innerHTML;
    updateProductCount(html);
    return true;
  }

  function fetchSection(path, searchParams) {
    var sectionId = getSectionId();
    if (!sectionId) return Promise.reject(new Error('Missing product grid section'));

    var url = path + '?section_id=' + encodeURIComponent(sectionId);
    if (searchParams) url += '&' + searchParams;

    setLoading(true);
    return fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        replaceProductGrid(html);
        setLoading(false);
        return html;
      })
      .catch(function (error) {
        setLoading(false);
        throw error;
      });
  }

  function applyFilterParams(searchParams, pill) {
    var path = getHubPath();
    history.replaceState({ erideCategory: true, searchParams: searchParams }, '', path + (searchParams ? '?' + searchParams : ''));
    setActivePill(pill);
    return fetchSection(path, searchParams);
  }

  function applyCollectionHandle(handle, pill) {
    var path = '/collections/' + handle;
    history.replaceState({ erideCategory: true, collectionHandle: handle }, '', getHubPath() + '?category=' + encodeURIComponent(handle));
    setActivePill(pill);
    return fetchSection(path, '');
  }

  function applyAllParts(pill) {
    var hubPath = getHubPath();
    history.replaceState({ erideCategory: true, category: 'all' }, '', hubPath + '?category=all');
    setActivePill(pill);
    return fetchSection(hubPath, '');
  }

  function onPillClick(event) {
    var pill = event.currentTarget;
    var mode = pill.dataset.categoryMode;
    if (!mode) return;

    event.preventDefault();

    if (mode === 'all') {
      applyAllParts(pill);
      return;
    }

    if (mode === 'collection') {
      applyCollectionHandle(pill.dataset.collectionHandle, pill);
      return;
    }

    if (mode === 'filter') {
      var param = pill.dataset.filterParam;
      var value = pill.dataset.filterValue;
      if (!param || !value) return;
      var searchParams = param + '=' + encodeURIComponent(value);
      applyFilterParams(searchParams, pill);
    }
  }

  function resolveInitialPill() {
    var toolbar = document.querySelector('[data-eride-collection-hub]');
    var params = new URLSearchParams(window.location.search);
    var categoryHandle = params.get('category');

    if (categoryHandle) {
      if (categoryHandle === 'all') {
        var allPill = document.querySelector('[data-eride-category-pill][data-category-mode="all"]');
        if (allPill) return allPill;
      }
      var collectionPill = findPillByMode('collection', categoryHandle);
      if (collectionPill) return collectionPill;
    }

    for (var pair of params.entries()) {
      if (pair[0].indexOf('filter') === 0) {
        var filterPill = document.querySelector(
          '[data-eride-category-pill][data-category-mode="filter"][data-filter-param="' + CSS.escape(pair[0]) + '"][data-filter-value="' + CSS.escape(pair[1]) + '"]'
        );
        if (filterPill) return filterPill;
      }
    }

    var defaultHandle = toolbar ? toolbar.dataset.defaultCollectionHandle : '';
    if (defaultHandle) {
      var defaultPill = document.querySelector(
        '[data-eride-category-pill][data-category-mode="collection"][data-collection-handle="' + CSS.escape(defaultHandle) + '"]'
      );
      if (defaultPill) return defaultPill;
    }

    return document.querySelector('[data-eride-category-pill][data-category-mode="all"]');
  }

  function shouldSkipInitialFetch(toolbar) {
    var hasQuery = window.location.search.length > 1;
    if (hasQuery) return false;

    var grid = document.getElementById('product-grid');
    var displayed = grid && grid.dataset.erideDisplayCollection;
    var defaultHandle = toolbar.dataset.defaultCollectionHandle;

    return Boolean(displayed && defaultHandle && displayed === defaultHandle);
  }

  function initHub() {
    var toolbar = document.querySelector('[data-eride-collection-hub]');
    if (!toolbar) return;

    document.querySelectorAll('[data-eride-category-pill]').forEach(function (pill) {
      pill.addEventListener('click', onPillClick);
    });

    var initialPill = resolveInitialPill();
    if (!initialPill) return;

    var hasQuery = window.location.search.length > 1;
    var isHub = toolbar.dataset.erideCollectionHub === 'true';

    if (hasQuery) {
      setActivePill(initialPill);
      return;
    }

    if (shouldSkipInitialFetch(toolbar)) {
      setActivePill(initialPill);
      return;
    }

    if (isHub) {
      toolbar.classList.add('is-loading');
      onPillClick({ preventDefault: function () {}, currentTarget: initialPill });
      return;
    }

    var grid = document.getElementById('product-grid');
    var currentHandle = grid && grid.dataset.erideDisplayCollection;
    if (currentHandle) {
      var matchingPill = findPillByMode('collection', currentHandle);
      if (matchingPill) {
        setActivePill(matchingPill);
        return;
      }
    }

    setActivePill(initialPill);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHub);
  } else {
    initHub();
  }
})();
